
define( 'FORCES_AND_MOTION_BASICS/../nls/hu/forces-and-motion-basics-strings',{
          "none": "nincs",
          "force": "Erő",
          "values": "erőértékkel",
          "frictionTitle": "Súrlódás",
          "redWins": "Győzött a piros!",
          "frictionForce": "Súrlódási erő",
          "pause": "Állj!",
          "friction": "Súrlódás",
          "accelerationLab": "Gyorsulás labor",
          "forces-and-motion-basics.name": "Erők és mozgás - alapok",
          "appliedForce": "Alkalmazott erő",
          "leftForce": "Balra mutató erő",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Jobbra mutató erő",
          "acceleration": "Gyorsulás",
          "sound": "Hanggal",
          "lots": "jó nagy",
          "forces": "Erők",
          "motion": "Mozgás",
          "tugOfWar": "Kötélhúzás",
          "go": "Húzd!",
          "newtons.n": "newton (N)",
          "sumOfForcesEqualsZero": "Eredő erő = 0",
          "blueWins": "Győzött a kék!",
          "speed": "Sebesség",
          "sumOfForces": "Eredő erő ",
          "return": "Vissza!",
          "translation.credits": "<html><a href=\"http://nagysandor.eu/\">Nagy Sándor</a><br>ELTE, <a href=\"http://www.chem.elte.hu/pr/\">Kémiai Intézet</a>, Budapest</html>",
          "newtons": "newton",
          "masses": "Tömegek",
          "forceReadout.pattern": "{0} N"
        } );